import Vue from 'vue';
import App from './App/App.vue';
import router from './router';
import ApiService from './services/api.service';
import i18n from './plugins/i18n';
import { AuthPlugin } from './plugins/auth';
import Notifications from 'vue-notification';
import VueI18n from 'vue-i18n';
import VueTelInput from 'vue-tel-input';
import store from './store-vuex';

// tslint:disable-next-line: no-var-requires
const JsonExcel = require ('vue-json-excel').default;

Vue.component('downloadExcel', JsonExcel);
Vue.config.productionTip = false;
Vue.use(AuthPlugin);
Vue.use(Notifications);
Vue.use(VueI18n);
Vue.use(VueTelInput);

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_PUBLIC_ROOT_API);
